import { Account, AccountInfo } from 'app/api/@generated/backend';

import { api } from 'app/api/common';

class CustomerService {
    public static readonly getAccounts = async (): Promise<Account[]> => api.accountController.getCustomerAccount();

    public static readonly getAccountInfo = async (billingAccountId: string, partnerId: string): Promise<AccountInfo> =>
        api.accountController.getAccountInfo({
            billingAccountId,
            partnerId,
        });
}

export { CustomerService };
